import React from 'react';
import cx from 'classnames';

import { FullThemeStyle, PANDA_FULL_COLORS } from '../../panda';
import { Scroll } from '../Scroll';

import './style.css';

/**
 * Drawer component.
 */
interface IDrawer {
  /** Passed down classname. */
  className?: string;
  /** Mandatory children */
  children: React.ReactNode;
  /** Theme colors */
  theme?: FullThemeStyle;
  /** Passed styles */
  style?: object;
}

export const Drawer: React.FC<IDrawer> = ({
  className,
  children,
  theme = FullThemeStyle.blue,
  style,
}) => {
  const combinedDrawerClass = cx({
    'panda-drawer': true,
    [className || '']: !!className,
  });

  return (
    <Scroll
      className={combinedDrawerClass}
      style={{ ...style, backgroundColor: PANDA_FULL_COLORS[theme] }}
    >
      <div className="panda-drawer-content">{children}</div>
    </Scroll>
  );
};
